export const SET_BANK_ACCOUNT = 'setBankAccount'
